import { Button, message, Spin, Tabs, Form, Upload } from 'antd'
import React, { Component } from 'react'
import { FaCloudUploadAlt, FaDownload, FaEye, FaFilePdf, FaTimes } from 'react-icons/fa'
import { connect } from 'react-redux';
import { GetFinancingRequestDetails } from '../../network/customer.network';
import DeleteModal from '../DeleteModal/DeleteModal';
import "./ClientDocs.scss"; 
import { UploadFinancingRequestFile } from '../../network/profile.network';
import { deleteDoc } from '../../network/request.network';

const { TabPane } = Tabs;

class ClientDocs extends Component {

  state = {
    FinancingRequestDetails  : null,
    FinanceRequestFiles : [],
    FinanceRequestFilesNotUploaded : [],
    FinanceRequestFilesUploaded : [], 
    showDltModal  : false,
    tableLoading  : false,
  }

  componentDidMount() {
    this.handelGetFinancingRequestDetails();
  }

  handelGetFinancingRequestDetails = () => { 
    let {orderId} = this.props;
    this.setState({tableLoading : true})
    GetFinancingRequestDetails(orderId, (res) => {
      // const FileTypesWithoutUpload = this.props.FileTypes?.filter(ele => )
      this.setState({
        FinancingRequestDetails : res.data.model, 
        FinanceRequestFiles : res.data.model.FinanceRequestFiles}, () => {
          this.handelAllFileUploadOrNot();
        });
      // this.props.dispatch(setUserRequest(res.data.model));
    }, (err) => { 
      this.setState({tableLoading : false})  
    })
  }

  handelAllFileUploadOrNot = () => {
    const {FinanceRequestFiles} = this.state;
    const {FileTypes} = this.props;
    if(FileTypes){
      this.setState({tableLoading : false})
      let result = FileTypes.filter(o1 => !FinanceRequestFiles.some(o2 => o1.Id === o2?.FileType?.Id));
      this.setState({FinanceRequestFilesNotUploaded : result, FinanceRequestFilesUploaded : FinanceRequestFiles})
    }else{
      setTimeout(() => {
        this.handelAllFileUploadOrNot();
      }, 1000);
    }
  }

  
  handelChangeImg = (data, fileType) => {
    const {userRequest} = this.props;
    let {orderId} = this.props;
      this.setState({tableLoading : true})
      let body = new FormData();
      body.append("FileTypeId", fileType.Id);
      body.append("FinancingRequestId", orderId);
      body.append("File", data.file); 
      UploadFinancingRequestFile(body, (res) => {
        message.success("تمت إضافة المستند بنجاح");
        this.setState({
            FinanceRequestFiles : [...this.state.FinanceRequestFiles, res.data.model]}, () => {
          this.handelAllFileUploadOrNot(); 
        }) 
      }, (error) => {
        // message.error("حدث خطأ أثناء معالجة المستند");
      })
  }


  handeldeleteDoc = () => {
    const {docDltId} = this.state;
    deleteDoc(
      docDltId?.Id, 
      (res) => {
        message.success("تم حذف المستند بنجاح");
        this.setState({FinanceRequestFiles : this.state.FinanceRequestFiles.filter(ele => ele?.Id !== docDltId?.Id)}, () => {
          this.handelAllFileUploadOrNot(); 
        })
      },
      (error) => {
        this.setState({tableLoading : false})
        // console.log(error);
      }
    );
  };
  
  closeDltModal = () => {
    this.setState({ showDltModal: false });
  };

  handelDownloadFiles = () => {
    const {FinanceRequestFiles} = this.state;

    FinanceRequestFiles.map(element => {
      window.open(`${element.Path}`, element?.FileType?.NameLT);
    //   axios({
    //     url: `${element.Path}`,
    //     method: "GET",
    //     // headers: headers,
    //     responseType: "blob" // important
    // }).then(response => {
    //     const url = window.URL.createObjectURL(new Blob([response.data]));
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute(
    //         "download",
    //         `${element?.FileType?.NameLT}.${element?.FileType?.MimeType}`
    //     );
    //     document.body.appendChild(link);
    //     link.click();
    // });
      // setTimeout(() => {
      //   window.open(`${element.Path}`, element?.FileType?.NameLT);
      //   console.log(element) 
      // }, 500)
      
    });
  }

    render() {
      const {tableLoading, FinanceRequestFiles, showDltModal, FinanceRequestFilesUploaded, FinanceRequestFilesNotUploaded} = this.state;
      const {location} = this.props;
        return (
            <div className="client-info-wrapper cocuments-page">
              {showDltModal && <DeleteModal delete={this.handeldeleteDoc} name="المستند" 
              closeDltModal={this.closeDltModal} /> }

              <header className="client-header">
                <h2 className="header-title">المستندات</h2>
                <div className="header-btn-holder">
                  <Button
                    type="primary"
                    size="large"
                    ghost
                    className="blue-btn"
                    icon={<FaDownload />} 
                    onClick={this.handelDownloadFiles}
                    >
                    تحميل المستندات
                  </Button>
                </div> 
              </header>
              <Spin spinning={tableLoading}>
              <div className="docs-tabs">
                <Tabs defaultActiveKey="1">
                  <TabPane tab="العميل" key="1">
                <div className="form-content pt-30 grid-perc">
                    {FinanceRequestFilesUploaded?.filter(file => file?.FileType?.IsCustomerFile === true)?.map(doc => 
                      <div className="docs-holder" key={doc.Id}>
                          <h6 className="docs-title">{doc?.FileType?.NameLT}</h6>
                          <div className="doc-body">
                              <div className="browse-file-content">
                                <FaFilePdf />
                                <div className="browse-file-text">
                                <p>{doc?.FileType?.MimeType?.replace('application/',' ').replace('image/',' ')}</p>
                                  {/* <span>120.kb</span> */}
                                </div>
                              </div>
                              <div className="doc-action">
                              <a href={doc.Path} target="_blank">
                                <FaEye style={{color : '#C2A062'}} />
                              </a>
                              <a href={doc.Path} target="_blank">
                              <FaDownload style={{color : '#06ACCC', margin : "0 14px"}} />
                              </a>
                              <FaTimes style={{color : '#cc3524'}} 
                              onClick={() => this.setState({showDltModal : true, docDltId : doc})} />
                              </div>
                          </div>
                      </div>
                      )}
                    {FinanceRequestFilesNotUploaded?.filter(file => file.IsCustomerFile === true).map(file => 
                        <Form.Item
                          label={file.NameLT}
                          name={file.Id}
                          className="input-holder"
                            rules={[
                              {
                                required: !file.IsOptional,
                              },
                            ]}
                        >
                          <Upload
                            // listType="picture"
                            accept={file.MimeType}
                            maxCount={1}
                            // beforeUpload={() => false}
                            onChange={(data) => this.handelChangeImg(data, file)}
                            showUploadList={false}
                            beforeUpload={data => {
                              const reader = new FileReader();
                              reader.onload = e => {
                                // console.log(data, "sadfsd") 
                              };
                              return false;
                          }}
                          >
                            <div className="btn-upload">
                              <div className="upload-btn-holder">
                                <div className="browse-file-content">
                                  <FaCloudUploadAlt />
                                  <div className="browse-file-text">
                                    <p>قم بإسقاط الملفات هنا </p>
                                    <span>({file?.MimeType?.replace('application/',' ').replace('image/',' ')})</span>
                                  </div>
                                </div>
                                <h5 className="browse-file-p">أو تصفح الملفات</h5>
                              </div>
                            </div>
                          </Upload>
                        </Form.Item>
                    )}
                </div>
                  </TabPane>
                  <TabPane tab="المالك" key="2">
                  <div className="form-content pt-30 grid-perc">
                  {FinanceRequestFilesUploaded?.filter(file => file?.FileType?.IsCustomerFile === false)?.map(doc => 
                      <div className="docs-holder" key={doc.Id}>
                          <h6 className="docs-title">{doc?.FileType?.NameLT}</h6>
                          <div className="doc-body">
                              <div className="browse-file-content">
                                <FaFilePdf />
                                <div className="browse-file-text">
                                  <p>{doc?.FileType?.MimeType?.replace('application/',' ').replace('image/',' ')}</p>
                                  {/* <span>120.kb</span> */}
                                </div>
                              </div>
                              <div className="doc-action">
                              <a href={doc.Path} target="_blank">
                                <FaEye style={{color : '#C2A062'}} />
                              </a>
                              <a href={doc.Path} target="_blank">
                              <FaDownload style={{color : '#06ACCC', margin : "0 14px"}} />
                              </a>
                              <FaTimes style={{color : '#cc3524'}}
                              onClick={() => this.setState({showDltModal : true, docDltId : doc})} />
                              </div>
                          </div>
                      </div>
                      )}
                    {FinanceRequestFilesNotUploaded?.filter(file => file.IsCustomerFile === false).map(file => 
                        <Form.Item
                          label={file.NameLT}
                          name={file.Id}
                          className="input-holder"
                            rules={[
                              {
                                required: !file.IsOptional,
                              },
                            ]}
                        >
                          <Upload
                            listType="picture"
                            accept={file.MimeType}
                            maxCount={1}
                            onChange={(data) => this.handelChangeImg(data, file) }
                            action={null}
                            showUploadList={false}
                            beforeUpload={data => {
                              const reader = new FileReader();
                              reader.onload = e => {
                                // console.log(data, "sadfsd") 
                              };
                              return false;
                          }}
                          >
                            <div className="btn-upload">
                              <div className="upload-btn-holder">
                                <div className="browse-file-content">
                                  <FaCloudUploadAlt />
                                  <div className="browse-file-text">
                                    <p>قم بإسقاط الملفات هنا </p>
                                    <span>({file?.MimeType?.replace('application/',' ').replace('image/',' ')})</span>
                                  </div>
                                </div>
                                <h5 className="browse-file-p">أو تصفح الملفات</h5>
                              </div>
                            </div>
                          </Upload>
                        </Form.Item>
                    )}
                </div>
                  </TabPane>
                </Tabs>
              </div>
              </Spin>

            </div>
        )
    }
}
const mapStateToProps = (state) => ({
  FileTypes : state.user.metaData.FileTypes,
}) 
export default  connect(mapStateToProps)(ClientDocs); 
